@if ($selectedVersion() != null) {
    <!-- Canvas Header -->
    <div class="canvas-header">
        <div class="keep-left">
            <!-- Breadcrumb/título -->
            <span class="title">
                <a [routerLink]="$isCreate() ? [Enums.PagesPaths.FlowDefinitionList] : [Enums.PagesPaths.FlowDefinitionList, $flowDefinition().unitId]">
                    <span class="info-font breadcrumb-flowinbox" [matTooltip]="$flowInboxInfo()">
                        {{$flowInboxInfo()}}
                    </span>
                </a>

                <i class="fas fa-chevron-right mx-2"></i>

                <span class="title-name-container" featureHint="flowAreaHeaderTitle">
                    <span class="h5 title-name my-0" [matTooltip]="$flowDefinition().name">
                        {{$flowDefinition().name}}
                    </span>
                </span>
            </span>

            <!-- Tags -->
            <div class="tags" featureHint="flowAreaHeaderTags">
                <!-- Ativação -->
                <span class="fas fa-check-circle tag active"
                      matTooltip="Fluxo {{$flowDefinition().isActive ? 'ativo' : 'inativo'}}"
                      [class.on]="$flowDefinition().isActive"
                ></span>

                <!-- Publicação -->
                <span class="fas fa-cloud tag published"
                      matTooltip="Última versão do Fluxo {{$flowDefinition().isPublished ? '' : 'não '}}publicada"
                      [class.on]="$flowDefinition().isPublished"
                ></span>

                <!-- Configurações Imediatas Temporais -->
                <span class="fas fa-history tag hot-configs"
                      matTooltip="Fluxo {{$hasTemporalHotConfigs() ? '' : 'não '}}contém Configurações Imediatas Temporais ativadas"
                      [class.on]="$hasTemporalHotConfigs()"
                ></span>

                <!-- Modo Não Listado -->
                <span class="fas fa-eye-slash tag hot-configs"
                      matTooltip="Fluxo {{$flowDefinition().isUnlistedModeActive ? '' : 'não '}}está com Modo Não Listado ativado"
                      [class.on]="$flowDefinition().isUnlistedModeActive"
                ></span>
            </div>
        </div>

        <!-- Barra de tarefas -->
        <div class="keep-right">
            <!-- Versão -->
            <div class="form-group select-container my-0 mr-1" featureHint="flowAreaHeaderVersion">
                <label for="flowDefinitionVersion">Versão</label>
                <select class="form-control" id="flowDefinitionVersion" name="flowDefinitionVersion"
                        [ngModel]="$selectedVersion()"
                        (change)="changeVersion($event.target.value)"
                >
                    @for (option of $flowDefinitionVersionOptions(); track option) {
                        <option [value]="option">{{option}}</option>
                    }
                </select>
            </div>

            <!-- Ações -->
            <div featureHint="flowAreaHeaderActions">
                <button type="button" class="btn mr-1" matTooltip="Visualizar ações"
                        [disabled]="$isCreate()"
                        [ngClass]="$isCreate() ? 'btn-default read-only' : 'btn-outline-primary'"
                        (click)="actionsMatPopoverRef.open()"
                        (keyDown)="actionsMatPopoverRef.open()"
                >
                    <i class="fas fa-bolt"></i>
                    <span class="ml-1">Ações</span>
                </button>

                <popover [_popoverContent]="actionsPopoverContentTemplate" [_disabled]="$isCreate()" #actionsMatPopoverRef></popover>
                <ng-template #actionsPopoverContentTemplate>
                    <div class="actions-wrapper">
                        <!-- Publicar -->
                        @if (!$flowDefinition().isPublished) {
                            <div class="action px-2" (click)="publish()" (keyDown)="publish()">
                                <i class="fas fa-cloud-upload-alt"></i>
                                <span class="ml-2">Publicar</span>
                            </div>
                        }

                        <!-- Versionar -->
                        @if ($flowDefinition().isPublished) {
                            <div class="action px-2" (click)="newVersion()" (keyDown)="newVersion()">
                                <i class="fas fa-code-fork"></i>
                                <span class="ml-2">Versionar</span>
                            </div>
                        }

                        <!-- Clonar -->
                        <div class="action px-2" (click)="clone()" (keyDown)="clone()">
                            <i class="fas fa-clone"></i>
                            <span class="ml-2">Clonar</span>
                        </div>

                        <!-- Ativar -->
                        @if (!$flowDefinition().isActive) {
                            <div class="action px-2" (click)="activate()" (keyDown)="activate()">
                                <i class="fas fa-check-circle"></i>
                                <span class="ml-2">Ativar</span>
                            </div>
                        }

                        <!-- Desativar -->
                        @if ($flowDefinition().isActive && ($flowDefinition().isPublished || $flowDefinition().version > 1)) {
                            <div class="action px-2" (click)="deactivate()" (keyDown)="deactivate()">
                                <i class="fas fa-times-circle"></i>
                                <span class="ml-2">Desativar</span>
                            </div>
                        }

                        <!-- Remover -->
                        @if (!$flowDefinition().isPublished && $flowDefinition().version == 1) {
                            <div class="action px-2" (click)="delete()" (keyDown)="delete()">
                                <i class="fas fa-trash"></i>
                                <span class="ml-2">Remover</span>
                            </div>
                        }

                        <!-- Histórico de alterações -->
                        <div class="action px-2" (click)="loadHistory()" (keyDown)="loadHistory()">
                            <i class="fas fa-book-open"></i>
                            <span class="ml-2">Histórico de alterações</span>
                        </div>

                        <!-- Instanciar última versão -->
                        @if ($flowDefinition().isPublished || $flowDefinition().version > 1) {
                            <div class="action px-2" (click)="instantiate()" (keyDown)="instantiate()">
                                <i class="fas fa-external-link-alt"></i>
                                <span class="ml-2">Instanciar a última versão publicada</span>
                            </div>
                        }
                    </div>
                </ng-template>

                <popover [_popoverContent]="viewHistoryPopoverContentTemplate" #viewHistoryMatPopoverRef></popover>
                <ng-template #viewHistoryPopoverContentTemplate>
                    <div class="history-wrapper styled-scrollbar">
                        <div class="title entry py-1 px-2" [class.scrollbar]="$historyEntries().length > 18">
                            <h5>Histórico de Alterações por Usuário</h5>
                        </div>

                        @for (author of $auditAuthors(); track author) {
                            <div class="entry px-2 py-1">
                                <div class="col left">
                                    <i class="fas fa-user"></i>
                                    <span class="ml-1">{{author}}</span>
                                </div>

                                <div class="col right">
                                    @for (entry of $historyEntries(); track entry) {
                                        @if ((Utils.isNotNullOrEmpty(entry.auditUserName) ? entry.auditUserName : Enums.Messages.DefaultEmptyValue).startsWith(author)) {
                                            <div class="audit" matTooltip="{{entry.auditDate.split('*')[1]}}">
                                                <i class="fas fa-clock"></i>
                                                <span class="ml-1">{{entry.auditDate.split('*')[0]}}</span>
                                            </div>
                                        }
                                    }
                                </div>
                            </div>
                        }
                    </div>
                </ng-template>
            </div>

            <!-- Recarregar -->
            <div featureHint="flowAreaHeaderReload">
                <button type="button" class="btn mr-1" matTooltip="Recarregar conteúdo do Fluxo"
                        [disabled]="$isCreate()"
                        [ngClass]="$isCreate() ? 'btn-default read-only' : 'btn-outline-primary'"
                        (click)="reload()"
                        (keyDown)="reload()"
                >
                    <i class="fas fa-sync-alt"></i>
                    <span class="ml-1">Recarregar</span>
                </button>
            </div>

            <!-- Editar -->
            <div featureHint="flowAreaHeaderEdit">
                <button type="button" class="btn btn-outline-primary mr-1" matTooltip="Editar propriedades do Fluxo"
                        (click)="editFlowDefinition()"
                        (keyDown)="editFlowDefinition()"
                >
                    <i class="fas fa-pencil-alt"></i>
                    <span class="ml-1">Editar</span>
                </button>
            </div>

            <!-- Salvar -->
            <div featureHint="flowAreaHeaderSave">
                <button type="button" class="btn" matTooltip="Salvar alterações no Fluxo (&quot;Control&quot; + &quot;B&quot;)"
                        [disabled]="$isReadOnlyMode() || ($isCreate() && $selectedFlowObjectsLength() == 0)"
                        [ngClass]="$isReadOnlyMode() || ($isCreate() && $selectedFlowObjectsLength() == 0)
                            ? 'btn-default read-only'
                            : 'btn-outline-primary'
                        "
                        (click)="saveFlowDefinition()"
                        (keyDown)="saveFlowDefinition()"
                >
                    <i class="fas fa-save"></i>
                    <span class="ml-1">Salvar</span>
                </button>
            </div>
        </div>
    </div>
}
